<mat-form-field class="wd-100 customSelect" [floatLabel]="'auto'" appearance="fill">

    <mat-label>{{label}}</mat-label>

    <input matInput [formControl]="yearControl" [matDatepicker]="datepicker" readonly>

    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>

    <mat-datepicker #datepicker (yearSelected)="yearSelectedHandler($event, datepicker)" startView="multi-year"
        panelClass="year-picker">
    </mat-datepicker>

</mat-form-field>